<template>
<Row :gutter="10" type="flex">
  <i-col
  v-for="(infor, i) in data"
  :key="`infor-${i}`"
  class="summary__wrapper"
  >
  <div class="summary__card card__bg-1" :class="get_summary_conversion(i, 'bg')">
  <Row align="middle" type="flex">
  <Col span="9" offset="3"><span class="summary__card-tit">{{get_summary_conversion(i, 'name')}}</span></Col>
  <Col span="9" offset="3"><count-to :end="infor.total" countClass="summary__card__count-head"/></Col>
  </Row>
  <Row align="middle" type="flex" v-if="infor.offline!=null">
  <Col span="9" offset="3"><span class="summary__card-subtit">门店{{get_summary_conversion(i,'subname')}}</span></Col>
  <Col span="9" offset="3"><count-to :end="infor.offline" countClass="summary__card__count-sub"/></Col>
  </Row>
  <Row align="middle" type="flex" v-if="infor.online!=null">
  <Col span="9" offset="3"><span class="summary__card-subtit">线上{{get_summary_conversion(i,'subname')}}</span></Col>
  <Col span="9" offset="3"><count-to :end="infor.online" countClass="summary__card__count-sub"/></Col>
  </Row>
  <Row align="middle" type="flex" v-if="infor.offline_order_counts!=null">
  <Col span="9" offset="3"><span class="summary__card-subtit">{{$t('pages_dashboards_statement_sale_components_summary_386')}}</span></Col>
  <Col span="9" offset="3"><count-to :end="infor.offline_order_counts" countClass="summary__card__count-sub"/></Col>
  </Row>
  <Row align="middle" type="flex" v-if="infor.offline_unit_revenue!=null">
  <Col span="9" offset="3"><span class="summary__card-subtit">{{$t('pages_dashboards_statement_sale_components_summary_387')}}</span></Col>
  <Col span="9" offset="3"><count-to :end="infor.offline_unit_revenue" countClass="summary__card__count-sub"/></Col>
  </Row>
  <Row align="middle" type="flex" v-if="infor.online_order_counts!=null">
  <Col span="9" offset="3"><span class="summary__card-subtit">{{$t('pages_dashboards_statement_sale_components_summary_388')}}</span></Col>
  <Col span="9" offset="3"><count-to :end="infor.online_order_counts" countClass="summary__card__count-sub"/></Col>
  </Row>
  <Row align="middle" type="flex" v-if="infor.online_unit_revenue!=null">
  <Col span="9" offset="3"><span class="summary__card-subtit">{{$t('pages_dashboards_statement_sale_components_summary_389')}}</span></Col>
  <Col span="9" offset="3"><count-to :end="infor.online_unit_revenue" countClass="summary__card__count-sub"/></Col>
  </Row>
  <Row align="middle" type="flex" v-if="infor.offline_rate!=null">
  <Col span="9" offset="3"><span class="summary__card-subtit">{{$t('pages_dashboards_statement_sale_components_summary_390')}}</span></Col>
  <Col span="9" offset="3">
    <div style="display: flex;align-items: center;">
    <count-to :end="infor.offline_rate" countClass="summary__card__count-sub"/>
    <span class="summary__card-subtit">%</span>
    </div>
  </Col>
  </Row>
  <Row align="middle" type="flex" v-if="infor.online_rate!=null">
  <Col span="9" offset="3"><span class="summary__card-subtit">{{$t('pages_dashboards_statement_sale_components_summary_391')}}</span></Col>
  <Col span="9" offset="3">
    <div style="display: flex;align-items: center;">
      <count-to :end="infor.online_rate" countClass="summary__card__count-sub"/>
      <span class="summary__card-subtit">%</span>
    </div></Col>
  </Row>
  </div>
  </i-col>
</Row>
</template>
<script>
import i18n from '../../../../locales/index'

import CountTo from '_c/count-to'

export default {
  name: 'Summary',
  components: { CountTo },
  props: {
    data: {
      type: Object,
      function () {
        return {}
      }
    }
  },
  computed: {},
  methods: {
    get_summary_conversion (value, type) {
      const nameMap = new Map([['sale', i18n.t('pages_dashboards_statement_sale_components_summary_392')], ['discount', i18n.t('pages_dashboards_statement_sale_components_summary_393')], ['revenue', i18n.t('pages_dashboards_statement_product_components_summary_362')], ['order', i18n.t('pages_dashboards_statement_product_components_summary_363')], ['maoli', i18n.t('pages_dashboards_statement_product_components_summary_364')]])
      const bgMap = new Map([['sale', 'card__bg-1'], ['discount', 'card__bg-2'], ['revenue', 'card__bg-3'], ['order', 'card__bg-4'], ['maoli', 'card__bg-5']])
      const subnameMap = new Map([['sale', i18n.t('pages_dashboards_statement_product_components_summary_365')], ['discount', i18n.t('pages_dashboards_statement_sale_components_summary_394')], ['revenue', i18n.t('pages_dashboards_statement_product_components_summary_367')], ['order', i18n.t('pages_dashboards_statement_product_components_summary_368')], ['maoli', i18n.t('pages_dashboards_statement_product_components_summary_369')]])
      const map = { name: nameMap, bg: bgMap, subname: subnameMap }
      return map[type].get(value);
    }
  }
}
</script>
<style lang="less" scoped>
.summary{
  &__wrapper{
    height: 145px;
    padding-bottom: 10px;
    flex: 1;
  }
  &__card{
    /* background: #2d8cf0; */
    height: 100%;
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    color: #ffffff;
    &-tit{
      font-size: 1vw;
    }
    &-subtit{
      font-size: 0.8vw;
    }
    &__count{
      &-head {
        font-size: 20px;
        color: #ffffff;
      }
      &-sub {
        font-size: 1vw;
        color: #ffffff;
      }
    }
  }
}
.card__bg-1{
  background: center / 100% 100% no-repeat url('~@/assets/images/card_bg_1.png');
}
.card__bg-2{
  background: center / 100% 100% no-repeat url('~@/assets/images/card_bg_2.png');
}
.card__bg-3{
  background: center / 100% 100% no-repeat url('~@/assets/images/card_bg_3.png');
}
.card__bg-4{
  background: center / 100% 100% no-repeat url('~@/assets/images/card_bg_4.png');
}
.card__bg-5{
  background: center / 100% 100% no-repeat url('~@/assets/images/card_bg_5.png');
}
</style>
